export const EXAMINATION_REQUEST_GET_ONE_REQUEST = 'EXAMINATION_REQUEST_GET_ONE_REQUEST'
export const EXAMINATION_REQUEST_GET_ONE_SUCCESS = 'EXAMINATION_REQUEST_GET_ONE_SUCCESS'
export const EXAMINATION_REQUEST_GET_ONE_FAIL = 'EXAMINATION_REQUEST_GET_ONE_FAIL'
export const EXAMINATION_REQUEST_GET_ONE_RESET = 'EXAMINATION_REQUEST_GET_ONE_RESET'
